angular
	.module('app')
	.component('user', {
		templateUrl: 'modules/users/pages/user.html',
		controller: User,
		bindings: {
			permissions: '<',
            permissionPermissions: '<',
		}
	});

/**
 * gets a list of all permissions up front to populate permission modal
 *
 * @function      
 */
function User() { }